import service from '@/api/axios';

//  http请求机器载体
export function postSendOrder (data) {
  return service({
    url: '/work/operation/sendOrder',
    method: 'post',
    data
  })
}